import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        // 异步滚动操作  api：https://juejin.im/post/5b3f0860f265da0f8c0297ae
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({ x: 0, y: 1 });
            }, 0);
        });
    },
});

router.afterEach(to => {
    // 更改标题
    if (to.meta.title === 'PARTNER_NAME') {
        if (import.meta.env.VITE_APP_ENV === 'pre') {
            document.title = `${window.productConfig?.REACT_APP_PARTNER_NAME}预发环境`;
        } else {
            document.title = window.productConfig?.REACT_APP_PARTNER_NAME;
        }
    } else {
        document.title = to.meta.title;
    }
    console.log(window.productConfig);
    let userAgent = navigator && navigator.userAgent ? navigator.userAgent : '';
    if (userAgent.includes('AlipayClient')) {
        // 支付宝环境下禁用分享
        window.AlipayJSBridge.call('hideOptionMenu');
    } else if (userAgent.includes('MicroMessenger')) {
        // 微信环境下禁用分享
        window.WeixinJSBridge.call('hideOptionMenu');
    }
});

export default router;
